import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from "react-router-dom";
import Routes from './utils/routes/routes';
import 'antd/dist/reset.css';
import { ConfigProvider } from 'antd';
import { color } from './utils/themes/color';
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: color.primary,
        }
      }}
    >
      <Routes />
    </ConfigProvider>

  </BrowserRouter >
  // </React.StrictMode>
);


